import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useQueryFilter from 'hooks/useQueryFilter';
import useMatchMedia from 'hooks/useMatchMedia';
import ResolveMultiSelect from 'components/ResolveMultiSelect';
import utils from 'utils';
import { FIRST_PAGE } from 'data/global';
import {
  SUGGESTED_ACTIONS_ACTION_TYPE_KEY,
  SUGGESTED_ACTION_TYPE_LABEL,
  SUGGESTED_ACTION_TYPE_ORDER,
} from '../../suggestedActionsFilterData';

type SuggestedActionTypeFilterProps = {
  className?: string;
  pageKey?: string;
};

const SuggestedActionTypeFilter: React.FC<SuggestedActionTypeFilterProps> = (
  props,
) => {
  const { className, pageKey } = props;

  const { t } = useTranslation();

  const isPhablet = useMatchMedia('isPhablet');

  const { params, onFiltersApply, applyQueryFilter } = useQueryFilter();

  const selectedTypes = useMemo(
    () => utils.mapParamsToArray(params[SUGGESTED_ACTIONS_ACTION_TYPE_KEY]),
    [params],
  );

  const options = useMemo(
    () =>
      SUGGESTED_ACTION_TYPE_ORDER.map((type) => ({
        value: type,
        label: t(SUGGESTED_ACTION_TYPE_LABEL[type]),
      })),
    [t],
  );

  const handleChange = useCallback(
    (values: string[]) => {
      onFiltersApply(SUGGESTED_ACTIONS_ACTION_TYPE_KEY, values);
      if (pageKey) applyQueryFilter(pageKey, FIRST_PAGE);
    },
    [pageKey, onFiltersApply, applyQueryFilter],
  );

  const classes = classNames('suggested-action-type-filter', className);

  return (
    <ResolveMultiSelect
      className={classes}
      hasCheckbox
      searchable={false}
      renderAsPortal={!isPhablet}
      value={selectedTypes}
      options={options}
      pillText={t('actions')}
      onChange={handleChange}
    />
  );
};

export default SuggestedActionTypeFilter;
